import './style/ExcelExportExtension.scss';
import ExcelExportExtension from './js/ExcelExportExtension';

export default ExcelExportExtension;
